<template>
  <li v-if="link.type=='item item-divider'" class="nav-item toolbar-divider border-bottom"
      style="width: 200px;position:relative; font-weight: bold">
    {{ link.title[currentLanguage] }}
  </li>

  <li v-if="link.sublinks.length == 0 && link.type!='item item-divider' && !link.login_needed" class="nav-item toolbar-link"
      @click="openSubLinkOrRedirect(link)"
      style="width: 200px;position:relative; margin-left: 5px">
    <a class="nav-link active" aria-current="page" data-bs-dismiss="offcanvas" style="min-width:300px"
       :style="{'background-color':'#fff' ,'color':'#29B0E1' + '!important'}"> <i
        class="canvas-item-icon mobile-activated" :class="link.icon_style"></i>
      <font-awesome-icon style="width:20px"
                         class="canvas-item-icon " :style="{color: tileBgColor}"
                         v-if="link.icon_fa " :icon="[link.icon_fa.type, link.icon_fa.name]"/>

      {{ link.title[currentLanguage] }} </a><span
      v-if="link.target == '#/app/posts' && unreadNews > 0"
      class="position-absolute end-1   translate-middle badge rounded-pill bg-primary"
      style="top:20px">
                {{ unreadNews }}
              </span>

    <span
        v-if="link.target == '#/app/chat' && unreadTotal > 0"
        class="position-absolute end-1   translate-middle badge rounded-pill bg-primary"
        style="top:20px">
                {{ unreadTotal }}
              </span>
  </li>

  <li v-if="link.sublinks.length == 0 && link.type!='item item-divider' && link.login_needed" class="nav-item toolbar-link"
      style="width: 200px;position:relative; margin-left: 5px">
    <a class="nav-link active" aria-current="page" data-bs-dismiss="offcanvas" style="min-width:300px"
       :href="redirectLink" target="_blank"
       :style="{'background-color':'#fff' ,'color':'#29B0E1' + '!important'}"> <i
        class="canvas-item-icon mobile-activated" :class="link.icon_style"></i>
      <font-awesome-icon style="width:20px"
                         class="canvas-item-icon " :style="{color: tileBgColor}"
                         v-if="link.icon_fa " :icon="[link.icon_fa.type, link.icon_fa.name]"/>

      {{ link.title[currentLanguage] }} </a><span
      v-if="link.target == '#/app/posts' && unreadNews > 0"
      class="position-absolute end-1   translate-middle badge rounded-pill bg-primary"
      style="top:20px">
                {{ unreadNews }}
              </span>

    <span
        v-if="link.target == '#/app/chat' && unreadTotal > 0"
        class="position-absolute end-1   translate-middle badge rounded-pill bg-primary"
        style="top:20px">
                {{ unreadTotal }}
              </span>
  </li>

  <div v-if="link.sublinks.length > 0 && link.type!='item item-divider'" style="margin-left: 0 !important">
    <a class="nav-link dropdown-toggle"
       style="margin-left:5px;"
       :style="{'background-color':'#fff' ,'color':'#29B0E1' + '!important', 'border-bottom': '1px solid #29B0E1'}" @click="openSubLinkOrRedirect(link)" data-bs-dismiss="offcanvas">
      <i class="canvas-item-icon mobile-activated" :class="link.icon_style"></i>
      <font-awesome-icon style=";  !important; width:20px"
                         class="canvas-item-icon" :style="{color: tileBgColor}"
                         v-if="link.icon_fa " :icon="[link.icon_fa.type, link.icon_fa.name]"/>

      <div style="display:inline-block; width:210px; line-height:1rem;  white-space: normal;">
        {{ link.title[currentLanguage] }}
      </div>
    </a>
    <div v-for="sublink in link.sublinks" :key="sublink.id" style="font-size:14px; margin-left:0px !important; position: relative"
         class="nav-item toolbar-link py-1" >
      <a @click="openSubLinkOrRedirect(sublink)"
         style="margin-left: 5px; white-space: normal;max-width: 250px;"
         :style="{'color':'#000' + '!important'}" data-bs-dismiss="offcanvas"
      > <i class="canvas-item-icon mobile-activated" style="text-align:center;" :class="sublink.icon_style" v-if="1==2"></i>

        <font-awesome-icon style="width:20px"
                           class="canvas-item-icon " :style="{color: tileBgColor}"
                           v-if="sublink.icon_fa && 1 == 2" :icon="[sublink.icon_fa.type, sublink.icon_fa.name]"/>
        <div style="display:inline-block;  line-height:1rem;  white-space: normal; margin-left: 5px" :style="{'margin-left' : sublink.icon_fa ? '5px':'25px'}">
          {{ sublink.title[currentLanguage] }}
        </div>
      </a>
      <span
          v-if="sublink.target == '#/app/posts' && unreadNews > 0"
          class="position-absolute start-0 translate-middle badge rounded-pill bg-primary"
          style="top:20px">
                {{ unreadNews }}
              </span>

      <span
          v-if="sublink.target == '#/app/chat' && unreadTotal > 0"
          class="position-absolute start-0 translate-middle badge rounded-pill bg-primary"
          style="top:20px">
                {{ unreadTotal }}
              </span>

    </div>
  </div>

  <hr v-if="link.sublinks.length > 0 && link.type=='item item-divider'">

</template>


<script>
import {mapState, mapActions, mapGetters, mapMutations} from "vuex";
import {addIcons} from "ionicons";
import {
  personCircleOutline,
  chatbubbleOutline,
  syncOutline,
  logOutOutline,
  logInOutline,
  searchCircleOutline,
  homeOutline,
  chevronBackOutline,
  cloudOfflineOutline,
  menuOutline
} from "ionicons/icons";

addIcons({
  "sync-outline": syncOutline,
  "person-circle-outline": personCircleOutline,
  "log-out-outline": logOutOutline,
  "log-in-outline": logInOutline,
  "chatbubble-outline": chatbubbleOutline,
  "search-circle-outline": searchCircleOutline,
  "home-outline": homeOutline,
  "chevron-back-outline": chevronBackOutline,
  'cloud-offline-outline': cloudOfflineOutline,
  "menu-outline": menuOutline,
});
const config = require('@/config')
import router from '@/router';
import {alertController, isPlatform} from "@ionic/vue";

export default {
  components: {},
  props: ['link'],
  data() {
    return {
      menulinks: [],
      menulinksTop: [],
      title: config.full_name,
      isConsultant: false,
      userConsultant: null,
      isDesktop: null,
      isIos: null,
      video_chat_enabled: false,
      confDate: config.conf_date,
      openSubBar: false,
      sublinks: null,
      time: null,
      appointmentsRole: null,
      searchterm: '',
      hideSearchBar: false,
      historyCount: 0,
      loginAlertOpen: false,
      onLine: navigator.onLine,
      showBackOnline: false,
    }
  },
  computed: {
    ...mapState('sync', ['updateFinished', 'syncActive', 'downloadSize', 'downloadLabel', 'currentProgress']),
    ...mapGetters('auth', ['user', 'token']),
    ...mapState('splashscreen', ['showSplashscreen']),
    ...mapState('personalDB', ['unreadNews']),
    ...mapState('chat', ['currentChat', 'unreadTotal']),
    ...mapState('wordings', ['wordings', 'currentLanguage']),
    ...mapState('currentConference', ['currentConference', 'fullName', 'shortName', 'apiVersion', 'primaryColor', 'menuheader']),
    redirectLink: function () {
      return this.link.redirect + '?jwtoken=' + this.token;
    },
  },
  methods: {
    ...mapActions("settings", [
      "getSetting",
    ]),
    ...mapActions('sync', ['start']),
    ...mapActions("exhibitors", ["getAllExhibitors"]),
    ...mapActions('menulinks', ['isExternalLink']),
    ...mapActions('auth', ['GET_USERDATA', 'GENERATE_JWT']),
    ...mapMutations('splashscreen', ['setShowSplash', 'setShowHelp']),
    ...mapActions("personalDB", ["connectPersonalDB", 'getItem', 'getItems', 'prepareFavoriteList', 'setTime', 'getUnreadNews']),
    ...mapMutations('personalDB', ['setUnreadNews']),
    ...mapActions('chat', ['getUnreadMessagesTotalCount']),
    ...mapActions('googleanalytics', ['trackWithLabel']),

    async showHelpAgain() {
      localStorage.removeItem('helpSeen');
      this.setShowHelp(true);
    },

    goToChat() {
      if (this.user && this.user.id) {
        if(localStorage.getItem('chatConsentGiven_' + this.user.id) || this.user.consent_given == 'OPT_IN'){
          this.$router.push('/app/chat/');
        }else{
          this.consentAlert()
        }

      } else {
        this.chatAlert()
      }
    },

    async consentAlert() {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'Consent required',
            message: 'By using the chat portal, you are giving your consent to be visible to all WCLH participants.<br>Should you wish to remove yourself from the chat portal please contact us at <a href="mailto:unionconf2025.abstracts@abstractserver.com">unionconf2025.abstracts@abstractserver.com</a>',
            buttons: [
              {
                text: 'I disagree',
                role: 'cancel',
                cssClass: 'secondary',
                id: 'cancel-button',
                handler: blah => {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'I agree',
                id: 'confirm-button',
                handler: () => {
                  localStorage.setItem('chatConsentGiven_' +this.user.id, true)
                  this.$router.push('/app/chat/');
                },
              },
            ],
          });
      return alert.present();
    },

    async chatAlert() {
      const alert = await alertController
          .create({
            cssClass: 'my-custom-class',
            header: 'You need to be logged in in order to access the chat.',
            message: 'Do you want to log in?',
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                cssClass: 'secondary',
                id: 'cancel-button',
                handler: blah => {
                  console.log('Confirm Cancel:', blah)
                },
              },
              {
                text: 'Confirm',
                id: 'confirm-button',
                handler: () => {
                  this.login()
                },
              },
            ],
          });
      return alert.present();
    },
    async getRedirectLink(link) {
      let token = await this.GENERATE_JWT();
      return link.redirect + '?jwtoken=' + token
    },

    async openSubLinkOrRedirect(link) {
      this.trackWithLabel('menu_link:' + link.title.en)
      if (link.redirect == '/app/chat') {
        this.goToChat()
      } else {
        if (link.sublinks && link.sublinks.length > 0) {
          let external = await this.isExternalLink(link.target)
          if (external) {
            window.open(link.redirect, '_blank').focus();
          } else {
            router.push(link.redirect);
          }
        } else {
          let external = await this.isExternalLink(link.target)
          if (external) {
            window.open(link.redirect, '_blank').focus();
          } else {
            router.push(link.redirect);
          }
        }
      }

    },
  },

  mounted() {
  },
  beforeUnmount() {
  },

  watch: {}

};
</script>

